import { PopoverContent, PopoverCloseButton, Button, Box, Grid, GridItem, Checkbox, Input, Text, } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import MyDiv from './filterCard.style';
import { CheckIcon } from '@chakra-ui/icons';

export interface IFilter {
  id: number;
  name: string;
  parentId?: number;
}
export interface IRelation {
  parent: string;
  child: string;
}
export interface IFilterOptions {
  filterOptions: Record<string, IFilter[]>;
  relations?: IRelation[];
}

type FilterPopoverProps = {
  filter: IFilterOptions;
  defaulValues: Record<string, number[]>,
  onApplyFilter: (filters: Record<string, number[]>) => void;
  onClose?: () => void;
};

const FilterCardDropDownOnly = ({ filter, onApplyFilter, defaulValues, onClose, }: FilterPopoverProps) => {
  const categories = Object.keys(filter.filterOptions);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [search, setSearch] = useState('');
  const [selectedItems, setSelectedItems] = useState<Record<string, number[]>>(defaulValues);

  useEffect(() => {
    if (categories.length > 0 && !selectedCategory) setSelectedCategory(categories[0]);
  }, [categories, selectedCategory]);

  const handleCheckboxChange = (item: IFilter) => {
    setSelectedItems((prev: Record<string, number[]>) => {
      return { ...prev, [selectedCategory]: [item.id] };
    });
  };


  const handleReset = () => {
    setSelectedItems(defaulValues);
    setSearch('');
  };

  const handleApply = () => {
    onApplyFilter(selectedItems);
    onClose?.();
  };

  const options = () => {
    let parent: string | undefined;
    if (filter.relations && filter.relations.some(r => r.child === selectedCategory)) {
      parent = filter.relations.find(r => r.child === selectedCategory)?.parent;
    }
    const parentIds = selectedItems[parent ?? ''];
    if (parent) {
      return (filter.filterOptions[selectedCategory] || []).filter((item) => {
        return parentIds?.includes(item.parentId ?? 0) && (search === null || search === '' || (item.name && item.name.toLowerCase().includes(search.toLowerCase())));
      });
    } else {
      return (filter.filterOptions[selectedCategory] || []).filter((item) => {
        return search === null || search === '' || (item.name && item.name.toLowerCase().includes(search.toLowerCase()))
      });
    }
  }

  const hasSelectedItems = (category: string) => {
    return selectedItems[category] && selectedItems[category][0] > 0;
  };

  return (
    <MyDiv>
      <PopoverContent width="520px" borderRadius="10px" p={0}>
        <Box p={3} borderBottom="1px solid #ccc" position="relative">
          <Text className="font-poppins text_medium text_xsm" textAlign="center">Filter</Text>
          <PopoverCloseButton top="8px" right="12px" />
        </Box>
        <Box className="bg-filter" />
        <Grid templateColumns="1fr 1px 1.4fr">
          <GridItem>
            {categories.map((cat) => (
              <Box
                key={cat}
                px={6}
                py={3}
                cursor="pointer"
                position="relative"
                className={cat === selectedCategory ? 'text_bold' : 'text_regular'}
                borderBottom={
                  cat === selectedCategory
                    ? '2px solid rgba(0, 0, 0, 0.35)'
                    : '1px solid rgba(0, 0, 0, 0.1)'
                }
                onClick={() => {
                  setSelectedCategory(cat);
                  setSearch('');
                }}
              >
                {cat}
                {/* Add checkmark indicator */}
                {hasSelectedItems(cat) && (
                  <CheckIcon
                    color="green.500"
                    position="absolute"
                    right="12px"
                    top="50%"
                    transform="translateY(-50%)"
                    boxSize={3}
                  />
                )}
              </Box>
            ))}
          </GridItem>
          <GridItem className="bg-border" />
          <GridItem p={2} position="relative">
            <Input placeholder={`Search ${selectedCategory}`} mb={3} size="sm" value={search} onChange={(e) => setSearch(e.target.value)} />
            <Box className="checkbox-container">
              {options().map((item) => (
                <Box key={item.id} mb={3}>
                  <Checkbox isChecked={selectedItems[selectedCategory]?.some((id) => id === item.id) || false} onChange={() => handleCheckboxChange(item)}>
                    <Text className="font-poppins text_medium" fontSize="10px">{item.name}</Text>
                  </Checkbox>
                </Box>
              ))}
            </Box>
            <Box position="absolute" bottom="6px" right="26px">
              <Button variant="ghost" className="font-poppins text_medium text_xsm" onClick={handleReset} w="65px" h="25px" borderRadius="1px" mr={2}>Reset</Button>
              <Button className="font-poppins text_medium text_xsm btn_theme " w="65px" h="25px" borderRadius="6px" onClick={handleApply}>Apply</Button>
            </Box>
          </GridItem>
        </Grid>
      </PopoverContent>
    </MyDiv>
  );
};

export default FilterCardDropDownOnly;
